import { FC, useMemo } from "react";
import { useGummiwormContext } from "@/context/GummiwormContext";
import { assetIdKey, formatAssetLabel, formatAssetValue } from "@/lib/marketUtils";

export const AvailableBalance: FC = () => {
  const { accounts, myAccountId } = useGummiwormContext();

  const myAccount = useMemo(
    () => accounts.find((a) => a.accountId === myAccountId),
    [accounts, myAccountId],
  );

  const balances = useMemo(() => {
    if (!myAccount) return [];
    return myAccount.uncommittedValue.assets
      .filter((av) => av.value > 0n)
      .map((av) => ({
        key: assetIdKey(av.asset),
        label: formatAssetLabel(av.asset),
        formatted: formatAssetValue(av.asset, av.value),
      }));
  }, [myAccount]);

  return (
    <div className="rounded-xl bg-[#23141A] p-5">
      <h3 className="text-[11px] font-medium text-sr-neutral-300 uppercase tracking-wider mb-4">
        Available Balance
      </h3>
      <div className="flex flex-col gap-3">
        {balances.length === 0 ? (
          <span className="text-sm text-sr-neutral-500">
            {myAccountId == null ? "Connect wallet" : "No balances"}
          </span>
        ) : (
          balances.map((b) => (
            <div key={b.key} className="flex items-center justify-between">
              <span className="text-sm text-white">{b.label}</span>
              <span className="text-sm font-medium text-white tabular-nums font-display">
                {b.formatted}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
